module.exports = __webpack_public_path__ + "img/icon-number-six.8e670812.svg";